import React, { useState, useEffect } from "react";
import CustomTitle from "../../components/CustomTitle.jsx";
import { Flex, Space, Table, message, Typography, Form, Tooltip } from "antd";
import { AddItemButton, CustomParagraph } from "../../components/index.js";
import deleteIcon from "../../assets/images/delete.svg";
// import editIcon from "../../assets/images/edit-icon.svg";
import editIcon from "../../assets/images/edit-gray-icon.svg";
import { useNavigate } from "react-router-dom";
import { useToken } from "../../common/helper/index.js";
import { useSpin } from "../../components/SpinContext.js";
import { GetProducts, DeleteProduct } from "../../api's/onboarding";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchAllProducts,
  selectProductState,
} from "../../reudx-toolkit/slice/ProductSlice.js";
import TeamBadge from "../../components/TeamBadge.jsx";
import CommonDrawer from "../../components/CommonDrawer.jsx";
import SettingsProductDrawerForm from "./SettingsProductDrawerForm.jsx";
import CustomDeleteModal from "../Modals/CustomDeleteModal.jsx";
import { getPermissions } from "../../common/helper/getPermissions.js";

import {
  HumidityIcon,
  PressureIcon,
  TiltIcon,
  LightIcon,
  ShockIcon,
  TempratureRangeIcon,
  VibilityWindowIcon,
} from "../../assets/icons/icons.js";

const { Paragraph } = Typography;

const getTooltipContent = (record) => (
  <div
    style={{
      backgroundColor: "#333",
      color: "#fff",
      padding: '4px 8px',
      borderRadius: 4,
      fontSize: 13,
      lineHeight: 1.8,
      minWidth: 220,
    }}
  >
    <span style={{ fontSize: 12, fontWeight: '400' }}>Stability & handling requirements</span>
    <div className="tooltip-wrapper" style={{ marginTop: 4, fontSize: '10px' }}>
      {record.viability_window && (
        <div>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>

            <VibilityWindowIcon /> Transit viability window{" "}
          </span>

          <span style={{ float: "right" }}>{record.viability_window} hr</span>
        </div>
      )}

      {record.temperature_min && (
        <div>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>

            <TempratureRangeIcon /> Temperature range{" "}
          </span>

          <span style={{ float: "right" }}>
            {Math.round(record.temperature_min)} -{" "}
            {Math.round(record.temperature_max)}°{record.temperature_unit}
          </span>
        </div>
      )}

      {record.shock && (
        <div>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>

            <ShockIcon /> Shock{" "}
          </span>

          <span style={{ float: "right" }}>{Math.round(record.shock)} G</span>
        </div>
      )}
      {record.light && (
        <div>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>

            <LightIcon /> Light{" "}
          </span>
          <span style={{ float: "right" }}>{Math.round(record.light)} lux</span>
        </div>
      )}
      {record.tilt && (
        <div>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>

            <TiltIcon /> Tilt{" "}
          </span>

          <span style={{ float: "right" }}>{Math.round(record.tilt)} deg</span>
        </div>
      )}
      {(record?.pressure_min || record?.pressure_max) && (
        <div>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>

            <PressureIcon /> Pressure{" "}
          </span>
          <span style={{ float: "right" }}>
          {record.pressure_min ? Math.round(record.pressure_min) : "N/A"}-{record.pressure_max ? Math.round(record.pressure_max) : "N/A"} {record.pressure_unit}
          </span>
        </div>
      )}
      {(record?.humidity_min || record?.humidity_max) && (
        <div>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>

            <HumidityIcon /> Humidity{" "}
          </span>
          <span style={{ float: "right" }}>
            {record.humidity_min ? Math.round(record.humidity_min) : "N/A"}-{record.humidity_max ? Math.round(record.humidity_max) : "N/A"}%
          </span>
        </div>
      )}
    </div>
  </div>
);

const SettingsProductTable = ({ title }) => {
  const [productsList, setProductsList] = useState([]);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { token, removeToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const state = useSelector(selectProductState);
  const dispatch = useDispatch();
  const allTeams = useSelector((state) => state.teams.list);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [requestStatus, setRequestStatus] = useState(null);
  const [deleteData, setDeleteData] = useState(null);
  const [requirementCount, setRequirementCount] = useState(0);
  const [showDrawer, setShowDrawer] = useState(false);
  const [userID, setUserID] = useState("");
  const main_menu = useSelector((state) => state.menu.items);
  const ProductsPermissions = getPermissions(main_menu, "Settings", "Products");
  const handleCloseDrawer = () => {
    setUserID(null);
    setShowDrawer(false);
    form.resetFields();
    dispatch(fetchAllProducts(token));
  };

  useEffect(() => {
    if (dispatch) {
      dispatch(fetchAllProducts(token));
    }
  }, [dispatch]);

  const handleFetchAllProduct = () => {
    dispatch(fetchAllProducts(token));
  };

  //setting data from store
  useEffect(() => {
    if (state) {
      console.log('state : ', state)
      setRequestStatus(state?.status ? state.status : null);
      setProductsList([])
      if (state?.productList.length > 0) {
        setRequirementCount(state?.requirement_count ?? 0);
        setProductsList(state?.productList);
      }
    }
  }, [state]);

  //if status is unauthorize
  useEffect(() => {
    if (requestStatus) {
      unauthorize(requestStatus);
    }
  }, [requestStatus]);

  const unauthorize = (status) => {
    if (status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const allColumns = [
    {
      title: "Product name",
      dataIndex: "name",
      key: "name",
      width: "116px",
      render: (text) => (
        <div>
          <CustomParagraph
            noText="--"
            text={text}
            fontSize={12}
            fontWeight={600}
            color="#000"
            marginBottom={0}
          />
        </div>
      ),
    },
    {
      title: "Product type",
      dataIndex: "product_name",
      key: "product_name",
      width: "130px",
      render: (text) => (
        <div>
          <CustomParagraph
            noText="--"
            text={text}
            fontSize={12}
            fontWeight={400}
            color="#000"
            marginBottom={0}
          />
        </div>
      ),
    },
    {
      title: "Stage of development",
      dataIndex: "stage_of_development",
      key: "stage_of_development",
      render: (text) => (
        <div>
          <CustomParagraph
            noText="--"
            text={text}
            fontSize={12}
            fontWeight={400}
            color="#000"
            marginBottom={0}
          />
        </div>
      ),
    },
    {
      title: "Commercial value",
      dataIndex: "commercial_value",
      key: "commercial_value",
      render: (text) => (
        <div>
          <CustomParagraph
            noText="--"
            text={text}
            fontSize={12}
            fontWeight={400}
            color="#000"
            marginBottom={0}
          />
        </div>
      ),
    },
    // project id
    {
      title: "Project ID",
      dataIndex: "project_id",
      key: "project_id",
      render: (text) => (
        <div>
          <CustomParagraph
            noText="--"
            text={text}
            fontSize={12}
            fontWeight={400}
            color="#000"
            marginBottom={0}
          />
        </div>
      ),
    },
    // vibility window
    {
      title: "Transit viabil...",
      dataIndex: "viability_window",
      key: "viability_window",
      condition: (count) => count === 0,
      render: (text) => (
        <div>
          <CustomParagraph
            noText="--"
            text={text ? `${text} hr` : "--"}
            fontSize={12}
            fontWeight={400}
            color="#000"
            marginBottom={0}
          />
        </div>
      ),
    },
    // temprature
    {
      title: "Temp. range",
      dataIndex: "temperature_range",
      key: "temperature_range",
      condition: (count) => count == 0,
      render: (_, record) => {
        const minTemp = record.temperature_min || "-";
        const maxTemp = record.temperature_max || "-";
        const range = record.temperature_range || "";
        return (
          <div>
            <Paragraph
              style={{
                color: "#000",
                fontSize: "12px",
                fontWeight: "400",
                marginBottom: "0",
              }}
            >
              {range != "none" && (
                <div>{`${Math.round(minTemp)} °${record?.temperature_unit
                  } to ${Math.round(maxTemp)} °${record?.temperature_unit}`}</div>
              )}
              <div
                style={{
                  marginTop: "4px",
                  color: "#5E5E5E",
                  textTransform: "capitalize",
                  fontSize: "10px",
                }}
              >{`${range}`}</div>
            </Paragraph>
          </div>
        );
      },
    },
    // Stability & requirement
    {
      title: "Requirements",
      dataIndex: "requirements",
      key: "requirements",
      condition: (count) => count > 0,
      render: (_, record) => {
        return (
          <div className="stability-requirement-tooltip">
            {record?.non_null_criteria_count > 0 ?
              <Tooltip autoAdjustOverflow={true} title={getTooltipContent(record)} padding={0} color="transparent">
                <p className="requirement-tooltip-trigger">
                  {record?.non_null_criteria_count}
                </p>
              </Tooltip>
              :
              <p className="requirement-tooltip-trigger">
                {record?.non_null_criteria_count ? record?.non_null_criteria_count : 0}
              </p>
            }
          </div>
        );
      },
    },

    // teams
    {
      title: "Teams with access",
      dataIndex: "teams",
      key: "teams",
      render: (_, record) => {
        return (
          <div>
            {record?.teams?.length > 0 ? (
              <div className="flex gap-x-2 white-space-nowrap">
                <TeamBadge
                  color={record?.teams[0]?.color}
                  text={record?.teams[0]?.name}
                  tooltipText={record?.teams[0]?.name}
                />
                {record?.teams.length > 1 && (
                  <Tooltip
                    title={record.teams
                      .slice(1)
                      .map((team) => team.name)
                      .join(", ")}
                    placement="top"
                  >
                    <div
                      style={{
                        display: "inline-block",
                        cursor: "pointer",
                      }}
                    >
                      <TeamBadge
                        color={null}
                        text={`+ ${record?.teams.length - 1}`}
                      />
                    </div>
                  </Tooltip>
                )}
              </div>
            ) : (
              <>
                {" "}
                <div>--</div>{" "}
              </>
            )}
          </div>
        );
      },
    },

    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div>
          <Flex gap={6}>
            {record?.permissions?.is_update && (
              <Flex
                justify="center"
                align="center"
                style={{ width: "32px", height: "32px", cursor: "pointer" }}
              >
                <img src={editIcon} alt="" onClick={() => handleEdit(record)} />
              </Flex>
            )}
            {record?.permissions?.is_delete && (
              <Flex
                justify="center"
                align="center"
                style={{ width: "32px", height: "32px", cursor: "pointer" }}
              >
                <img
                  src={deleteIcon}
                  alt=""
                  onClick={() => handleDelete(record)}
                />
              </Flex>
            )}
          </Flex>
        </div>
      ),
    },
  ];


  // Filter columns based on `requirementCount`
  const columns = allColumns.filter(col =>
    !col.condition || col.condition(requirementCount)
  );

  //Table actions
  const handleDelete = (record) => {
    setDeleteData(record);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    setShowDeleteModal(false);
    if (deleteData && deleteData.id) {
      showSpin();
      DeleteProduct(deleteData.id, token)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data.data?.is_success) {
              message.success(data?.data?.message);
              setDeleteData(null);
              dispatch(fetchAllProducts(token));
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    }
  };

  const handleEdit = (record) => {
    let userId = record?.id ? record.id : "";
    setUserID(userId);
    setShowDrawer(true);
    // navigate(`/settings/product/form/${userId}`);
  };

  const TeamsFilteredColumns =
    allTeams?.length > 0
      ? columns
      : columns.filter((column) => column.key !== "teams");

  return (
    <>
      <div className="settings-content-wrapper">
        <CustomTitle
          text={`Products (${productsList?.length})`}
          fontSize={20}
          fontWeight="700"
          lineHeight="32px"
          color="#000"
          marginBottom={0}
        />

        {/* <Space direction="vertical"  style={{ width: "100%" }}> */}
        {/* <div className="product-table-list"> */}
        <Table
          columns={TeamsFilteredColumns}
          dataSource={productsList}
          pagination={false}
          className="settings-table"
          rowHoverable={false}
        />
        {/* </div> */}
        {ProductsPermissions?.is_create && (
          <AddItemButton
            marginTop="0px"
            fontSize="12px"
            fontWeight="600"
            text={"Add product"}
            onClick={() => {
              setShowDrawer(true);
            }}
          />
        )}
      </div>
      {/* </Space> */}
      {showDrawer && (
        <CommonDrawer open={showDrawer} onClose={() => handleCloseDrawer()}>
          <SettingsProductDrawerForm
            form={form}
            id={userID}
            handleCloseDrawer={handleCloseDrawer}
            handleFetchAllProduct={handleFetchAllProduct}
          />
        </CommonDrawer>
      )}
      <CustomDeleteModal
        visible={showDeleteModal}
        onConfirm={() => handleConfirmDelete()}
        onClose={() => setShowDeleteModal(false)}
        title={`Remove product`}
        message={`Removing this product will prevent selecting it for future use.`}
        cancelText={"Cancel"}
        confirmText={"Remove"}
        confirmColor={`#DE1135`}
      />
    </>
  );
};

export default SettingsProductTable;
